import React, { Fragment, memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import FourThirdCard from '~/components/Card/FourThirdCard';
import { Typo } from 'tmt-ui-kit';

const TripContainer = styled.div`
  @media only screen and (max-width: 1200px) {
    margin-left: -16px;
    margin-right: -16px;
    >h2 {
      margin-left: 16px;
    }
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  @media only screen and (max-width: 1200px) {
    overflow-x: scroll;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
  @media only screen and (max-width: 1200px) {
    padding-left: 16px;
  }
`;

const CardWrapper = styled.div`
  width: 31.95%;
  margin-top: 16px;
  margin-right: 16px;
  &:nth-child(3n+3) {
    margin-right: 0px;
  }
  @media only screen and (max-width: 1200px) {
    width: 40%;
    flex: none;
    &:nth-child(3n+3) {
      margin-right: 16px;
    }
  }
  @media only screen and (max-width: 600px) {
    width: 70%;
  }
`;

const TripCreatedTitle = styled(Typo.HeaderTwo)`
  margin-top: 8px;
  margin-bottom: 0;
`;

const LocalExpertTrips = (props) => {
  const trips = props.trips.filter((trip) => trip.product_type === 'trip');
  const { addToConversionSource, lxName } = props;
  return (
    <Fragment>
      {trips.length > 0 && (
        <TripContainer>
          <TripCreatedTitle>
            Trips created by {lxName}
          </TripCreatedTitle>
          <CardContainer>
            {trips.map((trip, index) => (
              <CardWrapper onClick={() => addToConversionSource('local-expert-page', trip._id)}>
                <FourThirdCard desktopColumn="1-3" mobileColumn="65p" key={`trip-${index}`} data={trip} target="_self" hideStar />
              </CardWrapper>
            ))}
          </CardContainer>
        </TripContainer>
      )}
    </Fragment>
  );
};

LocalExpertTrips.propTypes = {
  lxName: PropTypes.object,
  trips: PropTypes.array,
  addToConversionSource: PropTypes.func
};

export default memo(LocalExpertTrips);
